/*
 * @Author: qinyang.li
 * @Date: 2026-01-12 10:30:00
 * @LastEditors: qinyang.li
 * @LastEditTime: 2026-01-19 10:34:55
 * @FilePath: /luckycorpweb/client/spa/apps/default/utils/watermark.js
 * @Description:
 */

import store from '../store';

/**
 * 水印
 */
class WatermarkService {
  static instance = null;
  constructor() {
    this.updateFunc = null; // SDK update 方法
    this.updateTimer = null; // 定时器
    this.loadSDK();
  }

  loadSDK() {
    const script = document.createElement('script');
    script.src =
      'https://unpkg.luckincoffeecdn.com/lucky-security@2.0.0/dist/index.umd.js';
    script.async = true;
    script.onload = () => this.createWatermark();
    script.onerror = () => {
      console.error('LuckySecuritySDK 加载失败');
    };
    document.head.appendChild(script);
  }

  /**
   * 初始化单例并创建水印
   * @returns {WatermarkService|null} 单例实例
   */
  static init() {
    if (!WatermarkService.instance) {
      try {
        WatermarkService.instance = new WatermarkService();
      } catch (e) {
        console.error('[WatermarkService] 水印初始化失败:', e);
        return null;
      }
    }
    return WatermarkService.instance;
  }

  /**
   * 格式化时间为 YYYY-MM-DD HH:mm
   * @returns {string} 格式化后的时间字符串
   */
  formatTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hour}:${minute}`;
  }

  /**
   * 获取水印内容
   * @returns {string} 完整的水印内容
   */
  getWatermarkContent() {
    const empName = store?.state?.user?.info?.empName || '';
    const mobile = store?.state?.user?.info?.mobile || '';
    const mobileLast4 = mobile.length >= 4 ? mobile.slice(-4) : '';
    const userIdentity = empName + mobileLast4;
    const projectName = 'corpweb';
    const timeStr = this.formatTime();
    return `${projectName} ${userIdentity} ${timeStr}`;
  }

  /**
   * 创建水印实例
   * @returns {Promise<void>}
   */
  async createWatermark() {
    try {
      const content = this.getWatermarkContent();
      const { update } = await window.LuckySecuritySDK.createWatermark({
        content,
        width: 270,
        height: 180,
        delay: 0
      });

      this.updateFunc = update;

      // 开始定时更新
      this.scheduleNextUpdate();

      console.log('[WatermarkService] 水印创建成功:', content);
    } catch (error) {
      console.error('[WatermarkService] 水印创建失败:', error);
    }
  }

  /**
   * 计划下一次更新（计算到下一个整分钟的精确时间）
   */
  scheduleNextUpdate() {
    clearTimeout(this.updateTimer);

    const now = new Date();
    const nextMinute = new Date(now);
    nextMinute.setMinutes(now.getMinutes() + 1);
    nextMinute.setSeconds(0);
    nextMinute.setMilliseconds(0);

    const delay = nextMinute.getTime() - now.getTime();

    this.updateTimer = setTimeout(() => {
      try {
        if (this.updateFunc) {
          const content = this.getWatermarkContent();
          this.updateFunc({ content });
          console.log('[WatermarkService] 自动更新水印:', content);
        }
        // 递归调用，安排下一次更新
        this.scheduleNextUpdate();
      } catch (error) {
        console.error('[WatermarkService] 定时更新失败:', error);
      }
    }, delay);
  }

  /**
   * 更新水印内容（用户信息变化时调用）
   */
  static update() {
    const instance = WatermarkService.instance;

    try {
      if (!instance?.updateFunc) {
        console.debug('[WatermarkService] 水印实例未创建，跳过更新');
        return;
      }

      const content = instance.getWatermarkContent();
      instance.updateFunc({ content });
      console.log('[WatermarkService] 水印更新成功:', content);

      // 重新计划下一次更新
      instance.scheduleNextUpdate();
    } catch (error) {
      console.error('[WatermarkService] 水印更新失败:', error);
    }
  }
}

// 导出类
export default WatermarkService;
